import React from "react";
import { IoMdClose } from "react-icons/io";
import { AiOutlineCheck } from "react-icons/ai";
import { terminalStatuses } from "utils/constants";
import { Modal, Typography, Button, Tag } from "components";

const StatusesTerminalModal = ({
  showModal,
  terminalStatusesQuery,
  handleModalClose,
  handleTerminalStatusQueryChange,
}) => {
  return (
    <Modal showModal={showModal} onClose={handleModalClose} customPadding={"0"}>
      <div className="report-filter-modal">
        <div className="header">
          <div className="d-flex justify-content-end ">
            <IoMdClose
              className="cursor-pointer"
              onClick={() => handleModalClose()}
            />
          </div>
          <Typography className={"text-center"}>
            Set Filter for Terminal report
          </Typography>
        </div>
        <Typography variant="body4" state="grey" className={"text-center mt-4"}>
          Select Terminal Status
        </Typography>
        <div className="status-selection-container">
          <div className="other-statuses">
            {terminalStatuses.map((prop, key) => (
              <div
                className="tag-container"
                key={key}
                onClick={() =>
                  handleTerminalStatusQueryChange({
                    name: "status",
                    value:
                      terminalStatusesQuery.status === prop.mapper
                        ? ""
                        : prop.mapper,
                  })
                }
              >
                {terminalStatusesQuery?.status === prop.mapper && (
                  <div className="check-icon">
                    <AiOutlineCheck
                      color={prop.color === "#FFFFFF" ? "#27AE60" : prop.color}
                    />
                  </div>
                )}

                <Tag
                  key={key}
                  {...{
                    textColor: prop.color,
                    backgroundColor: prop.bgColor,
                    text: prop.text,
                  }}
                  className="terminal-status-tag"
                  style={{
                    minWidth: "75px",
                    height: "28px",
                    cursor: "pointer",
                    fontSize: "4px",
                    margin: "0rem .2rem 1rem 0",
                  }}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="px-4 my-4">
          <Button
            label="Apply"
            size="xs"
            className={"mx-auto"}
            onClick={() => handleModalClose()}
          />
        </div>
      </div>
    </Modal>
  );
};

export default StatusesTerminalModal;
